import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@knockrentals/knock-shared-web-v2';
import ColorPickerCard from './ColorPickerCard';

const ColorPicker = ({
  brandColor,
  closeDialog,
  handleConfirmColor,
  isOpen,
}) => {
  return (
    <Dialog
      fullWidth={false}
      maxWidth={false}
      open={isOpen}
      onClose={closeDialog}
      size="xs"
      TransitionProps={{ mountOnEnter: true, unmountOnExit: true }}
    >
      <ColorPickerCard
        color={brandColor}
        onCancel={closeDialog}
        onConfirmColor={handleConfirmColor}
      />
    </Dialog>
  );
};

ColorPicker.propTypes = {
  brandColor: PropTypes.string,
  closeDialog: PropTypes.func,
  handleConfirmColor: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default ColorPicker;
